import React from "react";
import { Zap, BookOpen, GraduationCap } from "lucide-react";
import { cn } from "@/lib/utils";
import { useTranslation } from "@/context/LanguageContext";

const LEVELS = [
    { key: "quick", icon: Zap },
    { key: "standard", icon: BookOpen },
    { key: "expert", icon: GraduationCap },
];

// Compact Quick / Standard / Expert segmented control. Expert = "AI Professor".
export const DetailLevel = ({ value = "standard", onChange, className = "", showLabel = false, compact = false }) => {
    const { t } = useTranslation();
    return (
        <div className={cn("inline-flex items-center gap-1.5", className)}>
            {showLabel && <span className="mono-label text-t4">{t("detail.label")}</span>}
            <div className="flex rounded-lg bg-surface-2 p-0.5" data-testid="detail-level" role="tablist" aria-label={t("detail.label")}>
                {LEVELS.map((l) => {
                    const active = value === l.key;
                    const Icon = l.icon;
                    return (
                        <button
                            key={l.key}
                            data-testid={`detail-${l.key}`}
                            role="tab"
                            aria-selected={active}
                            title={t(`detail.${l.key}Hint`)}
                            onClick={() => onChange?.(l.key)}
                            className={cn(
                                "flex items-center gap-1 rounded-md px-2 py-1 text-[11px] font-medium transition-colors",
                                active ? "bg-surface-3 text-t1 shadow-elev-1" : "text-t3 hover:text-t1"
                            )}
                        >
                            <Icon className="h-3 w-3" />
                            {!compact && <span>{t(`detail.${l.key}`)}</span>}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};
